module.exports = __webpack_public_path__ + "static/media/fleetback-icon.18f9f84c.svg";